import EditNameModal from "./EditNameModal";
export default EditNameModal;
